import style from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={style.footer}>
      <p>{currentYear} @ Artemida Studio</p>
    </footer>
  );
};

export default Footer;
